module.exports = __webpack_public_path__ + "img/megaphone2.051c09af.png";